import React, { Component } from 'react';

export default class StampsDescription extends Component {
    render() {
        const { t } = this.props;

        return (
            <div className="stamps-description">
                <div className="stamps-description-row">
                    <div className="stamps-description-col">
                        <div className="stamps-description-item">
                            <h2 className="stamps-heading">
                                <b>Stamps</b>
                            </h2>
                            <p>
                                Repeatedly validated by reality, paperwork, and questionable authority.
                            </p>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
